export class BasicDialog {

    private _$dialog:JQuery;
    protected buttons:ModalButton[];
    protected cancelButton:ModalButton;
    protected acceptButton:ModalButton;

    private _title:string='';
    private _$content:JQuery=null;
    private _destoyOnHide:boolean=false;
    private width:string='';
    private height:string='';
    private onHide:()=>void;
    private beforeHide:(e:any)=>void;
    private zIndex:number=null;
    private maxHeightPercent=80;

    constructor(){
        this.CreateDefaultButtons();
    }

    protected DialogCreated($dialog:JQuery){

    }

    public get $Dialog():JQuery{
        if(this._$dialog==null)
        {
            this._$dialog=jQuery(`<div class="modal fade" id="myModal" role="dialog">
                                            <div class="modal-dialog">                                            
                                              <div class="modal-content">
                                                <div class="modal-header">
                                                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                  <h4 class="modal-title"></h4>
                                                </div>
                                                <div class="modal-body">
                                                  
                                                </div>
                                                <div class="modal-footer">                                                  
                                                </div>
                                              </div>
                                              
                                            </div>
                                          </div>`);

            this._$dialog.find('.modal-title').append(this._title);
            this._$dialog.find('.modal-body').append(this._$content);

            for(let button of this.buttons)
            {
                this.$Dialog.find('.modal-footer').append(button.GenerateButton());
            }

            this.DialogCreated(this._$dialog);

            this._$dialog.on('hidden.bs.modal',()=>{
                if(this._destoyOnHide)
                    this.Destroy();
                if(this.onHide!=null)
                    this.onHide();
            });

            this._$dialog.on('hide.bs.modal',(e)=>{
               if(this.beforeHide!=null)
                   this.beforeHide(e);
            });


            if(this.zIndex!=null)
                this._$dialog.css('z-index',this.zIndex+1);

            if(this.width!='')
                this._$dialog.find('.modal-dialog').css('width',this.width);

            if(this.height!='')
                this._$dialog.find('.modal-dialog').css('height',this.height);
            this._$dialog.find('.modal-body').css('overflow','auto');
            jQuery('body').append(this._$dialog);

            this.AdjustMaxHeight();


        }

        return this._$dialog;
    }

    public SetZIndex(index:number)
    {
        this.zIndex=index;
        return this;
    }

    public SetOnHide(callBack:()=>void)
    {
        this.onHide=callBack;
    }

    public SetBeforeHide(callBack:(e:any)=>void)
    {
        this.beforeHide=callBack;
    }

    public SetWidth(width:string){
        this.width=width;
    }

    public SetHeight(height:string){
        this.height=height;
    }


    public SetDestroyOnHide(){
        this._destoyOnHide=true;
        return this;
    }

    public SetTitle(title:string):this{
        this._title=title;
        return this;
    }

    public HideCancelButton(){
        this.buttons.splice(this.buttons.indexOf(this.cancelButton),1);
        return this;
    }

    public HideAcceptButton(){
        this.buttons.splice(this.buttons.indexOf(this.acceptButton),1);
        return this;
    }

    public SetContent($content:JQuery):this
    {
        this._$content=$content;
        return this;
    }

    public Show(){
            (this.$Dialog as any).modal('show');
            if(this.zIndex!=null)
            {
                let $backdrop:JQuery=this.$Dialog.data('bs.modal').$backdrop;
                if($backdrop!=null)
                    $backdrop.css('z-index',this.zIndex);
            }
            return this;
    }

    public Hide(){
        (this.$Dialog as any).modal('hide');
    }

    public SetAcceptButtonText(text:string)
    {
        this.acceptButton.text=text;
        return this;
    }

    public SetCancelButtonText(text:string)
    {
        this.cancelButton.text=text;
        return this;
    }

    public OnAccept(callBack:()=>void)
    {
        this.acceptButton.OnClick(callBack);
        return this;
    }

    public Destroy(){
        if(this._$dialog!=null)
            this._$dialog.remove();
    }


    protected CreateDefaultButtons() {
        this.buttons=[];
        this.cancelButton=new ModalButton('Cancel','danger','glyphicon glyphicon-remove',()=>{(this.$Dialog as any).modal('hide')});
        this.acceptButton=new ModalButton('Apply','success','glyphicon glyphicon-ok',()=>{(this.$Dialog as any).modal('hide')});
        this.buttons.push(this.cancelButton);
        this.buttons.push(this.acceptButton);
    }

    private AdjustMaxHeight() {
        let height=jQuery(window).height();
        if(height>0)
            this._$dialog.find('.modal-body').css('max-height',height*this.maxHeightPercent/100);
    }
}

export class ModalButton
{
    constructor(public text:string,public type:ModalButtonType, public iconClasses:string='',public callBack:()=>void=null)
    {

    }

    public OnClick(callback:()=>void){
        this.callBack=callback;
    }

    public GenerateButton():JQuery{
        let $button=jQuery(`<buttion data-dismiss="modal"></buttion>`);
        $button.attr('class','btn '+this.GetButtonTypeClass());
        let icon='';
        if(this.iconClasses!='')
        {
            icon=`<span class="${this.iconClasses}"></span> `;
        }
        $button.append(icon+this.text);

        if(this.callBack!=null)
        {
            $button.click(this.callBack);
        }
        return $button;
    }


    private GetButtonTypeClass() {
        switch(this.type)
        {
            case "danger":
                return 'btn-danger';
            case "success":
                return 'btn-success';
        }
        return '';
    }
}

export type ModalButtonType='danger'|'success'|string;